export const capitalizeStr = (str) => {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
}

export const capitalizeName = (name) => {
    const lowerCaseName = name.toLowerCase();
    return lowerCaseName.replace(/(^|[\s-]|[\s/]|[\s.])\S/g, s => s.toUpperCase());
}